import { createRouter, createWebHistory } from "vue-router";
import store from '@/store';
import { getToken, getAuthorizeUrl } from "@/utils";
import { getMenu, realLogin } from '@/api/login'
import { message } from 'ant-design-vue';

const router = createRouter({
  history: createWebHistory(process.env.NODE_ENV === 'production' || process.env.VUE_APP_BUILD == '1' ? '/' : undefined),
  routes: [
    {
      path: "/login",
      name: "loginPage",
      meta: { title: "loginPage" },
      component: () => import("@/views/login/index.vue"),
    },
    {
      path: "/tax-login",
      name: "taxLoginPage",
      meta: { title: "巡税宝", public: true },
      component: () => import("@/views/taxLogin/index.vue"),
    },
    {
      path: "/workspace",
      name: "workspace",
      redirect: "/workspace/performance",
      meta: { title: "工作台", public: true },
      component: () => import("@/views/workspace/index.vue"),
      children: [
        {
          path: "performance",
          name: "workspacePerformance",
          meta: { title: "绩效", public: true },
          component: () => import("@/views/common/performance/index.vue"),
        },
        {
          path: "certificate",
          name: "workspaceCertificate",
          meta: { title: "合格证", public: true },
          component: () => import("@/views/common/certificate/index.vue"),
        },
        {
          path: "meeting",
          name: "workspaceMeeting",
          meta: { title: "例会", public: true },
          component: () => import("@/views/common/meeting/index.vue"),
        },
      ],
    },
    {
      path: "/",
      name: "homePage",
      meta: { title: "home" },
      component: () => import("@/views/home/index.vue"),
      children: [{
        path: "/",
        name: "index",
        meta: { title: "首页" },
        component: () => import("@/views/index/index.vue"),
      }, {
        path: "/operationManualUser",
        name: "operationManualUser",
        meta: { title: "操作文档" },
        component: () => import("@/views/operationManual/user.vue"),
      }]
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'errorPage',
      meta: { hideInMenu: true },
      component: () => import('@/views/error/404.vue')
    },
    {
      path: "/test",
      name: "test",
      meta: { title: "test" },
      component: () => import("@/views/temp/test.vue"),
      children: []
    },
  ],
});

//处理路由数据
const getRouter = () => {
  const routers = store.getters.router || [];
  const newRouter = [];
  routers.map((v) => {
    if (v.component) {
      let permission = {};
      routers.filter(item => item.pid == v.id).map(item => {
        permission[item.permission.split(':')[1]] = true;
      });
      newRouter.push({
        path: v.path,
        name: v.name || v.path.slice(1),
        component: () => import(`@/${v.component}`),
        meta: { ...permission, title: v.title }
      });
    }
  });
  return newRouter;
};

let doAddRoute = false;
router.beforeEach((to, from, next) => {
  const token = getToken();
  if (to.meta.public) {
    next();
  } else if (to.query.authCode) {
    const authCode = 'Basic' + " " + btoa(to.query.authCode);
    store.dispatch('Login', authCode).then((res) => {
      let query = { ...to.query };
      delete query.code;
      delete query.authCode;
      delete query.state;
      router.replace({ path: to.path, query });
    }).catch(err => {
      message.error(err.errorMsg || '操作失败');
    });
  } else if (!token && to.path == '/login') {
    next();
  } else if (!token) {
    //window.location.href = getAuthorizeUrl(to.fullPath);
    next("/login");
  } else if (token && to.path == '/login') {
    next('/');
  } else if (token && !doAddRoute) {
    console.log('组装路由');
    doAddRoute = true;
    store.dispatch('GetMenu').then(data => {
      const addRouter = getRouter();
      addRouter.length && addRouter.map((v) => {
        if (v.path.includes('standalonePage')) {
          router.addRoute(v);
        } else {
          router.addRoute('homePage', v);
        }
      });
      if(to.fullPath == '/' && addRouter.some(item => item.path == '/home')) {
        next('/home')
      }else {
        next(to.fullPath);
      }
    }).catch((error) => {
      console.log(error)
      message.error('获取菜单失败');
      setTimeout(() => {
        next("/login");
      }, 1500);
    });
  } else {
    next();
  }
});

router.afterEach(() => {
  // console.log("routerAfterEach");
});

export default router;
